import styledCmp from 'styled-components'  
 
import { styled } from '@mui/material/styles'; 

import Checkbox from '@mui/material/Checkbox'; 

export const MaterialCheckbox = styled(Checkbox)(({ theme }) => ({  
}));
 